import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { allArticles } from '@/mocks/articles';

export default function Footer() {
  const guideArticles = allArticles.filter((a) => a.category === 'Guide' || a.category === 'Tutorial').slice(0, 5);
  const otherArticles = allArticles.filter((a) => !['Guide', 'Tutorial'].includes(a.category)).slice(0, 5);

  return (
    <footer className="bg-background-100 rounded-t-3xl mx-4 md:mx-6 mt-16">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-4">
            <Link to="/" className="inline-block cursor-pointer mb-4">
              <span className="font-heading text-xl font-extrabold text-foreground-900">
                OOPBuy <span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Your trusted resource hub for navigating the OOPBuy Spreadsheet ecosystem. 
              Discover guides, reviews, and category shortcuts to streamline your product sourcing journey.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-900 text-white hover:bg-foreground-800 transition-colors duration-200 cursor-pointer"
                aria-label="Visit Kaspreadsheet"
              >
                <i className="ri-external-link-line text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
                aria-label="Shop now"
              >
                <i className="ri-shopping-bag-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold uppercase tracking-widest text-foreground-500 mb-5">
              Categories
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold uppercase tracking-widest text-foreground-500 mb-5">
              &nbsp;
            </h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold uppercase tracking-widest text-foreground-500 mb-5">
              Guides
            </h4>
            <ul className="space-y-2">
              {guideArticles.map((article) => (
                <li key={article.slug}>
                  <Link
                    to={article.slug}
                    className="text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
                  >
                    {article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold uppercase tracking-widest text-foreground-500 mb-5">
              Resources
            </h4>
            <ul className="space-y-2">
              {otherArticles.map((article) => (
                <li key={article.slug}>
                  <Link
                    to={article.slug}
                    className="text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
                  >
                    {article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-300 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheet. This site is an independent informational resource. 
            We are not affiliated with Kaspreadsheet. All external links open in new tabs.
          </p>
          <Link to="/" className="text-xs text-primary-500 hover:text-primary-600 transition-colors duration-150 cursor-pointer font-medium whitespace-nowrap">
            Home
          </Link>
        </div>
      </div>
    </footer>
  );
}